import roundToTwoDecimals from './roundToTwoDecimals';

/**
 * Formats the given inches to readable form of feet and remainder of inches.
 * NOTE: All results are rounded to two decimal places by default.
 * e.g: 1.7779m -> 5 ft. 10 in.
 * @param {Number} inches
 */
const formatInchesToFeet = inches => {
  let feet = Math.floor(inches / 12);
  let remainder = roundToTwoDecimals(inches % 12);
  if (remainder === 12) {
    feet += 1;
    remainder = 0;
  }
  let formatted = `${feet} ft.`;
  if (remainder > 0) {
    formatted += ' ';
    formatted += `${remainder} in.`;
  }
  return formatted;
};

export default formatInchesToFeet;
